import { Flex, styled } from '@withjoy/joykit';

export const Wrapper = styled(Flex)<{ isBannerVisible: boolean }>`
  display: ${props => (props.isBannerVisible ? 'flex' : 'none')};
  position: relative;
  z-index: 3;
  top: 0rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.brandPurple5};
  flex-direction: row;
  min-height: 136px;
  padding: 1rem;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    min-height: 64px;
    padding: 0.75rem 1rem;
    align-items: center;
  }
`;

export const Information = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  padding-bottom: 0.75rem;
  ${({ theme }) => `color: ${theme.colors.white};`}
  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    padding-right: 1.5rem;
    padding-bottom: 0;
  }
`;

export const CloseButtonContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-left: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    flex-direction: row;
    > button {
      align-items: center;
    }
  }
`;

export const CTAButtonContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
`;

export const Spacer = styled(Flex)`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    display: flex;
  }
`;

export const ContentContainer = styled(Flex)`
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    flex-direction: row;
  }
`;
